import * as React from 'react';

import {DashboardFeed} from '../../ui/master-dashboard/sidebar/feed/feed';

export function TimelineRoot() {
    return <DashboardFeed hideFilters={true} />;
}
